import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer
} from '@mui/material';
import { IProdutoLoja } from '../../../../../../types/api/estoque/detalhar-produto-estoque';
import { formatarValorMonetario } from '../../../../../../helpers/masks';

interface CardInformacoesLojasProps {
    produtoLoja: IProdutoLoja[]
}

const CardInformacoesLojas: React.FC<CardInformacoesLojasProps> = ({
    produtoLoja
}) => {

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Informações do produto nas lojas
                </Typography>

                <TableContainer
                    sx={{ maxHeight: 300, overflow: 'auto' }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                    Loja
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                    Estoque atual
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                    Estoque disp. venda
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                    Preço
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {produtoLoja.map((loja, index) => (
                                <TableRow key={index} hover>
                                    <TableCell align="left">
                                        {loja.loja.id} - {loja.loja.nome}
                                    </TableCell>
                                    <TableCell align="right">
                                        {loja.estoque_atual}
                                    </TableCell>
                                    <TableCell align="right">
                                        {loja.estoque_disponivel_venda}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formatarValorMonetario(loja.preco)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default CardInformacoesLojas;